<script setup lang="ts">
import { RouterLink, useRouter } from "vue-router";

import { useSearchRoute } from "@/common/composables/use-search-route";
import { QUERY_CENTLEX_ELEMENT_ID_KEY } from "@/router/query-params";

interface Props {
  query: string;
  homonymId?: number | null;
  polysemId?: number | null;
}

const props = withDefaults(defineProps<Props>(), {
  homonymId: null,
  polysemId: null
});

const { getSearchRoute: getSearchQueryRoute } = useSearchRoute(useRouter());

const getSearchRoute = (query: string, homonymId: number | null, polysemId: number | null) => {
  const route = getSearchQueryRoute(query);

  if (homonymId !== null || polysemId !== null) {
    route.query[QUERY_CENTLEX_ELEMENT_ID_KEY] = `${homonymId ?? 0}-${polysemId ?? 0}`;
  }

  return route;
};
</script>

<template>
  <RouterLink
    :to="getSearchRoute(props.query, props.homonymId, props.polysemId)"
    class="article-content__text article-content__text--link"
  >
    {{ props.query }}
    <sup v-if="props.homonymId">
      {{ props.homonymId }}
    </sup>
    <sub v-if="props.polysemId">
      {{ props.polysemId }}
    </sub>
  </RouterLink>
</template>
